let navDrawerItems = [
  {
    development: true,
    icon: "mdi-file-document-box-multiple",
    label: "Documents",
    children: [
      {
        icon: "mdi-file-document-box-multiple",
        label: "Components",
        to: "/documents/components"
      },
      {
        icon: "mdi-function",
        label: "Functions",
        to: "/documents/functions"
      },
      {
        icon: "mdi-function-variant",
        label: "Store",
        to: "/documents/store"
      }
    ]
  },
  {
    development: true,
    icon: "mdi-share-variant",
    label: "Test Router",
    children: [
      {
        icon: "mdi-numeric-1",
        label: "Test Router 1",
        to: "/test-router-parent/test-router-1"
      },
      {
        icon: "mdi-numeric-2",
        label: "Test Router 2",
        to: "/test-router-parent/test-router-2"
      },
      {
        icon: "mdi-numeric-3",
        label: "Test Router 3",
        to: "/test-router-parent/test-router-3"
      }
    ]
  },
  {
    // hidden: true,
    id: "developer_config",
    development: true,
    icon: "$vuetify.icons.code",
    label: "开发者选项",
    to: "/developer/config"
  },
  {
    development: true,
    icon: "mdi-bug",
    label: "测试Debug",
    children: [
      {
        label: "组件调试",
        to: "/test-components/test-component-page"
      },
      {
        label: "系统Bug汇总"
      },
      {
        label: "代码任务汇总"
      }
    ]
  },
  {
    access: "useradminInst",
    icon: "$vuetify.icons.org",
    label: "机构管理",
    to: "/user-admin/institution"
  },
  {
    access: "useradminGroup",
    icon: "$vuetify.icons.group",
    label: "用户分组",
    children: [
      {
        access: "type",
        label: "分组类型",
        to: "/user-admin/group/type"
      },
      {
        access: "info",
        label: "分组信息",
        to: "/user-admin/group"
      }
    ]
  },
  {
    access: "useradminOrg",
    icon: "mdi-account-group",
    label: "单位管理",
    to: "/user-admin/organization"
  },
  {
    access: "useradminOrg",
    icon: "mdi-account-group",
    label: "预约分组管理",
    to: "/user-admin/ReservationGroupList"
  },
  {
    access: "useradminOrg",
    icon: "mdi-account-group",
    label: "合作单位管理",
    to: "/user-admin/cooperateOrganization"
  },
  /* {
    access: 'useradminOrg',
    icon: 'mdi-account-group',
    label: '合作单位管理',
    to: '/user-admin/organization'
  },*/
  {
    access: "useradminUser",
    icon: "$vuetify.icons.person",
    label: "用户管理",
    firstShow: "user_info",
    children: [
      {
        access: "superadmin",
        label: "用户管理(super admin)",
        to: "/user-admin/user/superAdmin"
      },
      /* {
        // access: 'Org',
        label: '机构管理',
        to: '/user-admin/institution'
      }, */
      /*  {
        // access: 'Group',
        label: '分组管理',
        to: '/user-admin/group'
      }, */
      /* {
        // access: 'Org',
        label: '单位管理',
        to: '/user-admin/organization'
      }, */
      {
        access: "perCheck",
        label: "登记用户",
        children: [
          {
            access: "admin",
            label: "预留信息管理",
            to: "/user-admin/user/register"
            // children: [
            //   {label: '教师管理'},
            //   {label: '学生管理'},
            //   {label: '合作用户管理'},
            // ]
          },
          {
            access: "checkAdmin",
            label: "登记用户管理",
            to: "/user-admin/user/binding"
          }
        ]
      },
      {
        access: "visitor",
        label: "访客用户"
      },
      {
        access: "role",
        label: "角色管理",
        to: "/user-admin/role"
      },
      {
        access: "permission",
        label: "权限管理",
        to: "/user-admin/permission"
      }
    ]
  },
  {
    icon: "mdi-parking",
    label: "园区管理",
    access: "park",
    children: [
      {
        label: "园区配置",
        to: "/parkControl/parkList",
        access: "park"
      },
      {
        label: "卡口配置",
        access: "controller",
        to: "/parkControl/controllerList"
      },
      {
        label: "物联业务管理",
        access: "iotService",
        to: "/parkControl/iotServiceList"
      },
      {
        label: "控制设备管理",
        access: "iotController",
        to: "/parkControl/deviceList"
      },
      {
        label: "硬件程序包管理",
        access: "hardwarePack",
        to: "/parkControl/packageList"
      }
    ]
  },
  {
    access: "passCheck",
    icon: "mdi-clipboard-check",
    label: "车辆登记",
    to: "",
    children: [
      {
        access: "commit",
        label: "车辆绑定",
        to: "/vehicleRegister/vehicleBind"
      },
      {
        access: "mycar",
        label: "我的车辆",
        to: "/vehicleRegister/selfVehicleList"
      },
      {
        access: "admin",
        label: "车辆审核",
        to: "/vehicleRegister/vehicleReviewList"
      },
      {
        access: "rule",
        label: "登记规则",
        to: "/vehicleRegister/registerConfig"
        /*    children: [
          {label: '全局配置'},
          {label: '单位配置'},
          {label: '个人配置'},
        ] */
      }
      // {
      //   // access: 'Search',
      //   label: '登记车辆查询',
      //   to: '/search-vehicle'
      // },
    ]
  },
  {
    access: "passOrder",
    icon: "$vuetify.icons.letter",
    label: "车辆预约",
    // access: 'VisitorReservation',
    children: [
      {
        access: "admin",
        label: "高级预约",
        to: "/reservation/admin/group"
      },
      {
        access: "letter",
        label: "函件预约",
        children: [
          {
            access: "commit",
            label: "函件预约申请",
            to: "/reservation/letterReservationList"
          },
          {
            access: "admin",
            label: "函件预约管理",
            to: "/reservation/letterReservationReview"
          }
        ]
      },
      {
        access: "org",
        label: "单位预约",
        to: "/reservation/organization"
      },
      {
        access: "person",
        label: "个人预约",
        to: "/reservation/personal"
      },
      {
        access: "rule",
        label: "预约规则",
        children: [
          {
            access: "admin",
            label: "高级预约规则",
            to: "/reservation/config/groupReservation"
          },
          {
            access: "letter",
            label: "函件预约规则",
            to: "/reservation/config/letterReservation"
          },
          {
            access: "org",
            label: "单位预约规则",
            to: "/reservation/config/organization"
          },
          {
            access: "person",
            label: "个人预约规则",
            to: "/reservation/config/personal"
          },
          {
            access: "selfService",
            label: "自助预约规则",
            to: "/reservation/config/selfService"
          },
          {
            access: "",
            label: "查询用户规则配置",
            to: "/reservation/config/searchConfig"
          }
        ]
      }
    ]
  },
  {
    access: "passObjectOrder",
    icon: "$vuetify.icons.phone",
    label: "行人预约",
    children: [
      {
        access: "admin",
        label: "高级预约",
        to: "/personReservation/admin"
      },
      {
        // access: 'Org',
        access: "org",
        label: "单位预约",
        to: "/personReservation/organization"
      },
      {
        // access: 'Person',
        access: "person",
        label: "个人预约",
        to: "/personReservation/personal"
      },
      {
        // access: 'Config',
        access: "rule",
        label: "预约配置",
        children: [
          {
            access: "admin",
            label: "高级预约规则",
            to: "/personReservation/config/groupReservation"
          },
          {
            access: "org",
            label: "单位预约规则",
            to: "/personReservation/config/organization"
          },
          {
            access: "person",
            label: "个人预约规则",
            to: "/personReservation/config/personal"
          },
          {
            access: "selfService",
            label: "自助预约规则",
            to: "/personReservation/config/selfService"
          }
        ]
      }
    ]
  },
  {
    icon: "mdi-cash-usd",
    label: "停车计费",
    access: "charging",
    children: [
      {
        access: "class",
        label: "计费规则分类",
        to: "/charging/ruleGroupList"
      },
      {
        access: "template",
        label: "计费规则模板",
        to: "/charging/ruleTemplateList"
      },
      {
        access: "rule",
        label: "计费规则配置",
        to: "/charging/ruleConfigList"
      },
      {
        access: "resutlt",
        label: "计费结果查询",
        to: "/charging/chargingHistory"
      },
      {
        access: "test",
        label: "计费模拟测试",
        to: "/charging/testRule"
      }
    ]
  },
  {
    icon: "mdi-currency-usd",
    label: "停车缴费",
    access: "payment",
    children: [
      {
        access: "bill",
        label: "账单查询",
        to: "/pay/billList"
      },
      {
        access: "wallet",
        label: "用户钱包",
        to: "/pay/userWalletList"
      },
      // {
      //   label: "用户钱包",
      //   to: "/pay/userDetails"
      // },
      {
        label: "模拟测试",
        to: "/pay/paySimulateTest"
      }
    ]
  },
  {
    access: "passObjectControl",
    icon: "mdi-human-male-boy",
    label: "行人管控",
    children: [
      // {
      //   access: 'Authority',
      //   label: '通行权限配置',
      //   to: '/pass-authority'
      // },
      {
        access: "simulate",
        // icon: 'mdi-car',
        label: "通行模拟",
        to: "/personPassControl/simulate"
      },
      {
        access: "obgrp",
        // icon: 'mdi-car',
        label: "通行分组",
        to: "/personPassControl/passGroupList"
      }
    ]
  },
  {
    access: "passControl",
    icon: "mdi-bus-clock",
    label: "车行管控",
    children: [
      // {
      //   access: 'Authority',
      //   label: '通行权限配置',
      //   to: '/pass-authority'
      // },
      {
        access: "obgrp",
        // icon: 'mdi-car',
        label: "登记车辆分组",
        to: "/passControl/passGroupList"
      },
      {
        access: "ban",
        label: "冻结车辆管理",
        to: "/passControl/blacklist"
      },
      {
        access: "limitArea",
        label: "限定性区域车辆管理",
        to: "/passControl/centerAreaVehicle"
      },
      {
        access: "simulate",
        // icon: 'mdi-car',
        label: "车辆通行模拟",
        to: "/passControl/simulate"
      },
      /*  {
        access: 'simulate',
        // icon: 'mdi-car',
        label: '硬件消息管理',
        to: '/passControl/iotControl'
      },*/
      {
        access: "rule",
        label: "车辆通行规则",
        children: [
          {
            access: "vehicle",
            label: "独立车辆",
            to: "/passControl/aloneVehicleList"
          },
          {
            access: "rule",
            label: "独立规则",
            to: "/passControl/aloneRuleList"
          }
        ]
      }
    ]
  },
  {
    access: "violation",
    icon: "mdi-alert",
    label: "违章处理",
    children: [
      {
        access: "list",
        label: "违章事件",
        to: "/violation/event"
      },
      {
        access: "rule",
        label: "违章规则",
        to: "/violation/rule"
      },
      {
        access: "area",
        label: "区域设置",
        to: "/violation/area"
      },
      {
        access: "log",
        label: "日志查询",
        to: "/violation/history"
      }
    ]
  },
  {
    access: "message",
    icon: "mdi-message-bulleted",
    label: "消息管理",
    children: [
      {
        access: "template",
        label: "消息模板",
        to: "/messageManagement/messageTemplate"
      },
      {
        access: "send",
        label: "手动填发",
        to: "/messageManagement/sendManagement"
      },
      {
        access: "log",
        label: "日志查询",
        to: "/messageManagement/messageLog"
      }
    ]
  },
  {
    access: "message",
    icon: "mdi-message-bulleted",
    label: "消息管理(新版)",
    development: true,
    children: [
      {
        access: "",
        label: "标签类别管理",
        to: "/message/class"
      },
      {
        access: "",
        label: "消息标签管理",
        to: "/message/label"
      },
      {
        access: "",
        label: "消息模板管理",
        to: "/message/template"
      },
      {
        access: "",
        label: "消息事件管理",
        to: "/message/event"
      },
      {
        access: "",
        label: "消息发送管理",
        children: [
          {
            label: "消息发送配置",
            to: "/message/send/sendConfig"
          }
        ]
      }
    ]
  },
  {
    access: "statistics",
    icon: "mdi-poll-box",
    label: "统计查询",
    children: [
      {
        access: "vehicleInfo",
        label: "车辆查询",
        to: "/statistics/vehicle"
      },
      {
        label: "登记用户",
        to: "/statistics/registerUser",
        access: "user"
      },
      {
        label: "访客用户",
        access: "visitor",
        to: "/statistics/visitorUser"
      },
      {
        access: "passLog",
        label: "车辆通行日志",
        to: "/statistics/passLog"
      },
      {
        access: "passObjectLog",
        label: "行人通行日志",
        to: "/statistics/personPassLog"
      }
    ]
  },
  {
    icon: "mdi-school",
    label: "进校管理",
    to: "",
    access: "temp",
    children: [
      {
        label: "进校补卡管理",
        access: "extraSign",
        children: [
          {
            access: "apply",
            label: "教工补卡申请",
            to: "/school/needSignList"
          },
          {
            label: "个人申请记录（补卡）",
            access: "self",
            to: "/school/selfExtraReviewList"
          },
          {
            label: "二级单位审核（补卡）",
            access: "first",
            to: "/school/firstExtraReviewList"
          },
          {
            label: "人事处审核（补卡）",
            access: "second",
            to: "/school/secondExtraReviewList"
          },
          {
            label: "校医院审核（补卡）",
            access: "hospital",
            to: "/school/hospitalExtraReviewList"
          }
        ]
      },
      {
        access: "blackAndWhite",
        label: "黑白名单管理",
        to: "/school/blackAndWhite"
      },
      {
        access: "teachers",
        label: "轮班教师管理",
        to: "/school/teacherManagement"
      },
      {
        access: "sign",
        label: "教工进校申请",
        to: "/school/selfApplList"
      },
      {
        access: "firstAudit",
        label: "二级单位审核",
        to: "/school/firstReviewList"
      },
      {
        access: "secondAudit",
        label: "业务部门审核",
        to: "/school/secondReviewList"
      },
      {
        access: "secondAdmin",
        label: "进校申请查询",
        to: "/school/allApplyList"
      },
      {
        access: "list",
        label: "进校登记日志",
        to: "/school/tempSignList"
      },
      {
        access: "addrecord",
        label: "进校打卡补卡",
        to: "/school/record"
      }
    ]
  }
];
export { navDrawerItems };
